(function () {
  'use strict';

  var config = window.MeilisearchProductGridConfig;
  if (!config) {
    console.error('[ms-pg] MeilisearchProductGridConfig not found.');
    return;
  }

  var MEILISEARCH_HOST = config.meilisearchHost;
  var MEILISEARCH_API_KEY = config.meilisearchApiKey;
  var MEILISEARCH_INDEX = config.meilisearchIndex;
  var collectionId = config.collectionId || null;
  var collectionHandle = config.collectionHandle || null;
  var currentLocale = config.currentLocale || 'de';
  var showOutOfStock = config.showOutOfStock !== false;
  var productsPerPage = config.productsPerPage || 24;
  var ETRUSTED_WIDGET_ID = config.etrustedWidgetId || '';
  var ETRUSTED_ACCENT_COLOR = config.etrustedAccentColor || '#ffdc0f';
  var searchMode = config.searchMode === true;
  var initialQuery = new URLSearchParams(window.location.search).get('q') || config.initialQuery || '';

  var _search = null;
  var _searchInitialized = false;

  var filterSettings = { filters: [], showOutOfStock: true };
  try {
    if (typeof config.filterSettings === 'string') {
      filterSettings = JSON.parse(config.filterSettings);
    } else if (config.filterSettings && typeof config.filterSettings === 'object') {
      filterSettings = config.filterSettings;
    }
  } catch (e) {
    console.error('[ms-pg] Error parsing filterSettings:', e);
  }

  function escapeHtml(text) {
    if (text == null) return '';
    var d = document.createElement('div');
    d.textContent = String(text);
    return d.innerHTML;
  }

  function formatPrice(amount, currency, forceDecimals) {
    if (amount == null || amount === '') return '';
    var num = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(num)) return '';
    var isWhole = num % 1 === 0;
    var decimals = forceDecimals ? 2 : (isWhole ? 0 : 2);
    var parts = num.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    var formatted = parts.join('.') + (!forceDecimals && isWhole ? '.-' : '');
    return currency ? currency + ' ' + formatted : formatted;
  }

  var SRCSET_WIDTHS = [200, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

  function shopifyImageUrl(src, width) {
    if (!src) return src;
    var sep = src.indexOf('?') !== -1 ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  function shopifySrcset(src) {
    if (!src) return '';
    return SRCSET_WIDTHS
      .map(function (w) { return shopifyImageUrl(src, w) + ' ' + w + 'w'; })
      .join(', ');
  }

  function getLocalizedTitle(hit) {
    return hit['title_' + currentLocale] || hit.title || 'Produkt';
  }

  function getImageUrl(hit) {
    if (hit.images && hit.images.length) {
      var img = hit.images[0];
      return typeof img === 'string' ? img : (img.src || img.url || '');
    }
    return '';
  }

  function sanitizeId(val) {
    return String(val).replace(/[^a-zA-Z0-9]/g, '_');
  }

  function getFilterLabel(filter) {
    if (filter.translations && filter.translations[currentLocale]) {
      return filter.translations[currentLocale];
    }
    return filter.label || filter.meilisearchField;
  }

  function getEffectiveField(filter) {
    if (filter.translatable && filter.meilisearchFields && filter.meilisearchFields[currentLocale]) {
      return filter.meilisearchFields[currentLocale];
    }
    return filter.meilisearchField;
  }

  function isSliderFilter(f) {
    return f.displayMode === 'slider' && f.numeric === true;
  }

  var DELIVERY_ICONS = {
    green_checked: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#39C177"/><g clip-path="url(#dg1)"><path d="M4.06445 8.56323L6.31364 10.8124L11.9366 5.18945" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="dg1"><rect width="9.6" height="9.6" fill="white" transform="translate(3.19922 3.19922)"/></clipPath></defs></svg>',
    green_full:    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#39C177"/></svg>',
    orange_hg:     '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#F99B0E"/><g clip-path="url(#dg2)"><path d="M11 12V11C11 10.05 10.55 9.1 9.75 8.55C9.6 8.45 9.5 8.3 9.5 8.15V7.85C9.5 7.7 9.6 7.55 9.75 7.45C10.55 6.9 11 5.95 11 5V4C11.3 4 11.5 3.8 11.5 3.5C11.5 3.2 11.3 3 11 3H5C4.7 3 4.5 3.2 4.5 3.5C4.5 3.8 4.7 4 5 4V5C5 5.95 5.45 6.9 6.25 7.45C6.4 7.55 6.5 7.7 6.5 7.85V8.1C6.5 8.25 6.4 8.4 6.25 8.5C5.45 9.1 5 10.05 5 11V12C4.7 12 4.5 12.2 4.5 12.5C4.5 12.8 4.7 13 5 13H11C11.3 13 11.5 12.8 11.5 12.5C11.5 12.2 11.3 12 11 12ZM6 11C6 10.35 6.3 9.75 6.85 9.35C7.25 9.05 7.5 8.6 7.5 8.15V7.85C7.5 7.35 7.25 6.9 6.85 6.6C6.3 6.25 6 5.65 6 5V4H10V5C10 5.65 9.7 6.25 9.15 6.65C8.75 6.95 8.5 7.4 8.5 7.85V8.1C8.5 8.6 8.75 9.05 9.15 9.35C9.7 9.75 10 10.35 10 11V12H6V11Z" fill="white"/></g><defs><clipPath id="dg2"><rect width="10" height="10" fill="white" transform="translate(3 3)"/></clipPath></defs></svg>',
    gray_qm:       '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8.70508" r="8" fill="#9FA6AB"/><path d="M7.86105 3.3156C8.86316 3.3156 9.66386 3.59069 10.2632 4.14087C10.8723 4.69104 11.1768 5.44262 11.1768 6.3956C11.1768 7.38788 10.8625 8.13455 10.2337 8.6356C9.60491 9.13666 8.76982 9.38718 7.72842 9.38718L7.66947 10.5514H6.21053L6.13684 8.23771H6.62316C7.57614 8.23771 8.30316 8.10999 8.80421 7.85455C9.31509 7.59911 9.57053 7.1128 9.57053 6.3956C9.57053 5.8749 9.41825 5.46718 9.11368 5.17245C8.81895 4.87771 8.40632 4.73034 7.87579 4.73034C7.34526 4.73034 6.92772 4.8728 6.62316 5.15771C6.3186 5.44262 6.16632 5.84052 6.16632 6.35139H4.58947C4.58947 5.76192 4.72211 5.23631 4.98737 4.77455C5.25263 4.3128 5.63088 3.9542 6.12211 3.69876C6.62316 3.44332 7.20281 3.3156 7.86105 3.3156ZM6.91789 13.8082C6.61333 13.8082 6.35789 13.7051 6.15158 13.4988C5.94526 13.2924 5.84211 13.037 5.84211 12.7324C5.84211 12.4279 5.94526 12.1724 6.15158 11.9661C6.35789 11.7598 6.61333 11.6567 6.91789 11.6567C7.21263 11.6567 7.46316 11.7598 7.66947 11.9661C7.87579 12.1724 7.97895 12.4279 7.97895 12.7324C7.97895 13.037 7.87579 13.2924 7.66947 13.4988C7.46316 13.7051 7.21263 13.8082 6.91789 13.8082Z" fill="white"/></svg>'
  };

  function getDeliveryIcon(lieferanzeige, fallback) {
    switch (lieferanzeige) {
      case 'Lieferbar ab Lager - Icon (Green full checkmark)':     return DELIVERY_ICONS.green_checked;
      case 'Dropshipping lieferbar - Icon (Green full dot)':       return DELIVERY_ICONS.green_full;
      case 'Liefertermin bekannt - Icon (Blue with Sandbox)':      return DELIVERY_ICONS.orange_hg;
      case 'Liefertermin unbekannt - icon (Grey with questionmark)': return DELIVERY_ICONS.gray_qm;
      default: return fallback;
    }
  }


  var _ps = window.productStrings || {};
  var deliveryTexts = {
    fast:       (_ps.deliveryDate || 'Lieferdatum') + ': 1-2 ' + (_ps.workingDays || 'Werktage'),
    datePrefix: (_ps.deliveryDate || 'Lieferdatum') + ': ',
    unknown:    _ps.deliveryDateUnknown || 'Lieferdatum zurzeit unbekannt',
    workingDays: _ps.workingDays || 'Werktage'
  };

  function getDeliveryStatus(hit) {
    var tags          = hit.tags || [];
    var isDropship    = tags.indexOf('cf_DropshippingDropshipping') !== -1;
    var variants      = hit.variants || [];
    var variantInStock = variants.some(function(v) { return (v.inventoryQuantity || 0) > 0; });
    var inStock       = (hit.totalInventory || 0) > 0 || variantInStock;
    var lieferanzeige = '';
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('cf_Lieferanzeige_') === 0) {
        lieferanzeige = tags[i].replace('cf_Lieferanzeige_', '');
        break;
      }
    }

    var langSuffix = currentLocale === 'de' ? 'de_ch' : currentLocale;
    var raw = hit['metafield_aico_aico_custom_fields_' + langSuffix];
    var metafields = [];
    if (Array.isArray(raw)) {
      metafields = raw;
    } else if (typeof raw === 'string' && raw) {
      try { metafields = JSON.parse(raw); } catch (e) { metafields = []; }
    }
    var nachlieferungKey   = 'nachlieferung_' + langSuffix;
    var nachlieferungEntry = null;
    for (var j = 0; j < metafields.length; j++) {
      if (metafields[j].key === nachlieferungKey) { nachlieferungEntry = metafields[j]; break; }
    }
    var nachlieferungRaw  = (nachlieferungEntry && nachlieferungEntry.value) || '';
    var hasNachlieferung  = false;
    var nachlieferungDate = '';
    if (nachlieferungRaw && nachlieferungRaw !== '01/01/01') {
      var ts = new Date(nachlieferungRaw).getTime();
      if (!isNaN(ts) && ts > Date.now()) {
        hasNachlieferung  = true;
        nachlieferungDate = new Date(nachlieferungRaw).toLocaleDateString(currentLocale === 'fr' ? 'fr-CH' : 'de-CH');
      }
    }

    var text, icon;
    var needsBrandLookup = false;

    if (!isDropship) {
      if (inStock) {
        text = deliveryTexts.fast;
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.green_checked);
      } else if (hasNachlieferung) {
        text = deliveryTexts.datePrefix + nachlieferungDate;
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.orange_hg);
      } else {
        text = deliveryTexts.unknown;
        icon = DELIVERY_ICONS.gray_qm;
      }
    } else {
      if (hasNachlieferung) {
        text = deliveryTexts.datePrefix + nachlieferungDate;
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.orange_hg);
      } else if (inStock) {
        text = deliveryTexts.fast;
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.green_checked);
      } else {
        // Case 6: dropship + out of stock + no restock — needs brand API lookup
        text = '';
        icon = '';
        needsBrandLookup = true;
      }
    }

    return { icon: icon, text: text, needsBrandLookup: needsBrandLookup, vendor: hit.vendor || '', lieferanzeige: lieferanzeige };
  }

  function fetchBrandDeliveryData(brand) {
    var apiUrl = window.API_URL || (typeof API_URL !== 'undefined' ? API_URL : '');
    var auth = window.Authorization || (typeof Authorization !== 'undefined' ? Authorization : '');
    // No token needed, aico calls go through the app proxy
    if (!apiUrl) return Promise.resolve(null);

    var endpoint = apiUrl + 'brands?filter[shouldExcludeProducts]=1&filter[isLightVersion]=0&filter[name]=' + encodeURIComponent(brand);
    return fetch(endpoint, {
      method: 'GET',
      headers: { Authorization: auth, Accept: 'application/vnd.api+json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    }).then(function (data) {
      return data.data && data.data[0] && data.data[0].attributes ? data.data[0].attributes : null;
    }).catch(function (err) {
      console.error('[ms-pg] fetchBrandDeliveryData error:', err);
      return null;
    });
  }

  function fetchBrandDeliveryDays() {
    var container = document.getElementById('ms-hits');
    if (!container) return;
    var els = container.querySelectorAll('.ms-delivery-status[data-needs-brand-lookup="true"]');
    if (!els.length) return;

    var vendorMap = {};
    els.forEach(function (el) {
      var vendor = el.getAttribute('data-vendor') || '';
      if (!vendor) return;
      if (!vendorMap[vendor]) vendorMap[vendor] = [];
      vendorMap[vendor].push(el);
    });

    Object.keys(vendorMap).forEach(function (vendor) {
      fetchBrandDeliveryData(vendor).then(function (brandData) {
        var elements = vendorMap[vendor];
        if (brandData && brandData.numberOfDeliveryDays) {
          elements.forEach(function (el) {
            var lieferanzeige = el.getAttribute('data-lieferanzeige') || '';
            el.querySelector('.ms-delivery-icon').innerHTML = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.green_full);
            el.querySelector('.ms-delivery-text').textContent = deliveryTexts.datePrefix + brandData.numberOfDeliveryDays + ' ' + deliveryTexts.workingDays;
            el.removeAttribute('data-needs-brand-lookup');
          });
        } else {
          elements.forEach(function (el) {
            el.querySelector('.ms-delivery-icon').innerHTML = DELIVERY_ICONS.gray_qm;
            el.querySelector('.ms-delivery-text').textContent = deliveryTexts.unknown;
            el.removeAttribute('data-needs-brand-lookup');
          });
        }
      });
    });
  }

  function renderHitHtml(hit) {
    var title = getLocalizedTitle(hit);
    var currency = (hit.price && hit.price.currency) || 'CHF';
    var price = (hit.price && parseFloat(hit.price.minPrice)) ||
      (hit.variants && hit.variants[0] && parseFloat(hit.variants[0].price)) || 0;
    var compareAtPrice = (hit.variants && hit.variants[0] && parseFloat(hit.variants[0].compareAtPrice)) || 0;
    var isSale = compareAtPrice > 0 && compareAtPrice > price;
    var isNew = hit.isNew === true;
    var imgSrc = getImageUrl(hit) || 'https://aico.apps.aico.swiss/images/no-images.png';
    var imgSrc2 = (hit.images && hit.images.length > 1)
      ? (typeof hit.images[1] === 'string' ? hit.images[1] : (hit.images[1].src || hit.images[1].url || ''))
      : '';
    var handle = hit.handle || hit.product_handle || '';
    var url = '/products/' + handle;
    var sku = (hit.variants && hit.variants[0] && hit.variants[0].sku) || '';
    var delivery = getDeliveryStatus(hit);

    var tags = hit.tags || [];
    var showPercentage = tags.join(',').indexOf('Preisanzeige_in_Rabatt') !== -1;

    var saleBadge = '';
    if (isSale) {
      var discountText = showPercentage
        ? '-' + Math.round((compareAtPrice - price) / compareAtPrice * 100) + '%'
        : '-' + formatPrice(compareAtPrice - price, currency, true);
      saleBadge = `
        <div class="ms-card-badge">
          <span class="ms-badge">
            <span class="ms-badge-text">
              ${discountText}
            </span>
          </span>
        </div>
      `;
    }

    var priceHtml = '';
    if (isSale && compareAtPrice > 0) {
      priceHtml = `
        <div class="ms-price">
          <div class="ms-price-sale">
            <span class="ms-price-sale-item">${formatPrice(price, null)}</span>
            <span>
              <s class="ms-price-regular-item">
                <span class="ms-statt-label">statt</span>
                ${formatPrice(compareAtPrice, null)}
              </s>
            </span>
          </div>
        </div>
      `;
    } else {
      priceHtml = `<div class="ms-price ms-price-regular">${formatPrice(price, null)}</div>`;
    }

    return `
      <li class="ms-product-card-container">
        <div class="ms-product-card">
          <div class="ms-card-top-icon">
            ${saleBadge}
          </div>

          <div class="ms-card-image">
            <a href="${url}" aria-label="${title}" ${imgSrc2 ? 'class="ms-has-second-image"' : ''}>
              <img class="ms-img ms-img-primary"
                src="${shopifyImageUrl(imgSrc, 540)}"
                srcset="${shopifySrcset(imgSrc)}"
                sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
                alt="${escapeHtml(title)}"
                loading="eager">
              ${imgSrc2 ? `<img class="ms-img ms-img-secondary"
                src="${shopifyImageUrl(imgSrc2, 540)}"
                srcset="${shopifySrcset(imgSrc2)}"
                sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
                alt="${escapeHtml(title)}"
                loading="lazy">` : ''}
            </a>
          </div>

          <div class="ms-card-content">
            ${priceHtml}
            <div class="ms-product-rating">${ETRUSTED_WIDGET_ID && sku ? `<etrusted-widget data-etrusted-widget-id="${ETRUSTED_WIDGET_ID}" data-sku="${escapeHtml(sku)}" data-accent-color="${ETRUSTED_ACCENT_COLOR}"></etrusted-widget>` : ''}</div>
            <div class="ms-card-title">
              <h3><a href="${url}">${title}</a></h3>
            </div>
            <div class="ms-delivery-status"${delivery.needsBrandLookup ? ` data-needs-brand-lookup="true" data-vendor="${escapeHtml(delivery.vendor)}" data-lieferanzeige="${escapeHtml(delivery.lieferanzeige)}"` : ''}>
              <span class="ms-delivery-icon">${delivery.icon}</span><span class="ms-delivery-text">${escapeHtml(delivery.text)}</span>
            </div>
          </div>

          <div class="ms-product-view">
            <a href="${url}">Ansehen</a>
          </div>
        </div>
      </li>

    `;
  }

  function renderSkeletons(count) {
    var b = 'background:#e5e5e5;border-radius:8px;';
    var card =
      '<li class="ms-product-card-container" style="pointer-events:none">' +
        '<div class="ms-product-card" style="min-height:420px">' +
          '<div class="ms-card-top-icon"><div style="' + b + 'width:60px;height:22px;border-radius:15px"></div></div>' +
          '<div class="ms-card-image"><div style="' + b + 'width:100%;height:200px"></div></div>' +
          '<div style="padding:15px;display:flex;flex-direction:column;gap:10px">' +
            '<div style="' + b + 'height:18px;width:85%"></div>' +
            '<div style="' + b + 'height:18px;width:55%"></div>' +
            '<div style="' + b + 'height:14px;width:100px"></div>' +
            '<div style="' + b + 'height:24px;width:90px"></div>' +
          '</div>' +
        '</div>' +
      '</li>';
    var html = '';
    for (var i = 0; i < count; i++) html += card;
    return html;
  }

  function checkAndInit() {
    if (_searchInitialized) return true;
    if (typeof window.instantsearch !== 'undefined' && typeof instantMeiliSearch !== 'undefined') {
      _searchInitialized = true;
      startSearch();
      return true;
    }
    return false;
  }

  function initSearch() {
    if (checkAndInit()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (checkAndInit() || attempts > 50) {
        clearInterval(timer);
        if (attempts > 50) console.error('[ms-pg] InstantSearch libraries failed to load.');
      }
    }, 100);
  }

  function startSearch() {
    var searchClient = instantMeiliSearch(MEILISEARCH_HOST, MEILISEARCH_API_KEY, {
      primaryKey: 'id',
      finitePagination: true,
      keepZeroFacets: false
    });

    var baseFilters = [];
    if (collectionId) baseFilters.push('collections.id = ' + collectionId);
    if (!showOutOfStock) baseFilters.push('(totalInventory > 0 OR variants.inventoryPolicy = "CONTINUE")');
    var baseFilterString = baseFilters.join(' AND ');

    var DEFAULT_SORT = MEILISEARCH_INDEX + ':filter_score:desc';

    var sortedFilters = (filterSettings.filters || [])
      .filter(function (f) {
        if (!f.excludedOnCollections || !f.excludedOnCollections.length) return true;
        return f.excludedOnCollections.indexOf(collectionHandle) === -1;
      })
      .sort(function (a, b) { return a.position - b.position; });

    _search = window.instantsearch({
      indexName: DEFAULT_SORT,
      searchClient: searchClient.searchClient,
      insights: false,
      routing: {
        stateMapping: {
          stateToRoute: function (uiState) {
            var idx = uiState[Object.keys(uiState)[0]] || {};
            var route = {};
            if (idx.refinementList) {
              Object.keys(idx.refinementList).forEach(function (attr) {
                var vals = idx.refinementList[attr];
                if (vals && vals.length) {
                  var key = attr.indexOf('filter_') === 0 ? attr.slice(7) : attr;
                  route[key] = vals.join(',');
                }
              });
            }
            // Sliders: write _min / _max independently
            sortedFilters.forEach(function (f) {
              if (!isSliderFilter(f)) return;
              var s = sliders[f.meilisearchField];
              if (!s) return;
              var urlKey = f.meilisearchField.indexOf('filter_') === 0 ? f.meilisearchField.slice(7) : f.meilisearchField;
              if (s.appliedMin != null) route[urlKey + '_min'] = s.appliedMin;
              if (s.appliedMax != null) route[urlKey + '_max'] = s.appliedMax;
            });
            if (idx.sortBy && idx.sortBy !== DEFAULT_SORT) {
              route.sort = idx.sortBy.replace(MEILISEARCH_INDEX + ':', '');
            }
            if (searchMode && idx.query) route.q = idx.query;
            return route;
          },
          routeToState: function (route) {
            var reserved = { sort: true, q: true };
            var filterKeys = {};
            sortedFilters.forEach(function (f) {
              if (isSliderFilter(f)) {
                var urlKey = f.meilisearchField.indexOf('filter_') === 0 ? f.meilisearchField.slice(7) : f.meilisearchField;
                reserved[urlKey + '_min'] = true;
                reserved[urlKey + '_max'] = true;
                return;
              }
              var effField = getEffectiveField(f);
              var short = f.meilisearchField.indexOf('filter_') === 0
                ? f.meilisearchField.slice(7)
                : f.meilisearchField;
              filterKeys[short] = effField;
              if (effField !== f.meilisearchField) {
                var effShort = effField.indexOf('filter_') === 0 ? effField.slice(7) : effField;
                filterKeys[effShort] = effField;
              }
            });
            var refinementList = {};
            Object.keys(route).forEach(function (key) {
              if (reserved[key]) return;
              var attr = filterKeys[key] || key;
              if (route[key]) refinementList[attr] = route[key].split(',');
            });
            var state = {};
            if (Object.keys(refinementList).length) state.refinementList = refinementList;
            // Restore range filters
            var range = {};
            function buildRangeStr(rawMin, rawMax) {
              var mn = (rawMin != null && rawMin !== '') ? parseFloat(rawMin) : NaN;
              var mx = (rawMax != null && rawMax !== '') ? parseFloat(rawMax) : NaN;
              if (isNaN(mn) && isNaN(mx)) return null;
              return (isNaN(mn) ? '' : mn) + ':' + (isNaN(mx) ? '' : mx);
            }
            sortedFilters.forEach(function (f) {
              if (!isSliderFilter(f)) return;
              var ef = getEffectiveField(f);
              var urlKey = f.meilisearchField.indexOf('filter_') === 0 ? f.meilisearchField.slice(7) : f.meilisearchField;
              var s = buildRangeStr(route[urlKey + '_min'], route[urlKey + '_max']);
              if (s) range[ef] = s;
            });
            if (Object.keys(range).length) state.range = range;
            if (route.sort) state.sortBy = MEILISEARCH_INDEX + ':' + route.sort;
            if (searchMode) state.query = route.q || initialQuery;
            var uiState = {};
            uiState[DEFAULT_SORT] = state;
            return uiState;
          }
        }
      }
    });

    var configureOptions = { hitsPerPage: productsPerPage };
    if (baseFilterString) configureOptions.filters = baseFilterString;
    _search.addWidgets([window.instantsearch.widgets.configure(configureOptions)]);

    var fieldLabelMap = {};
    sortedFilters.forEach(function (f) {
      var eff = getEffectiveField(f);
      fieldLabelMap[f.meilisearchField] = getFilterLabel(f);
      if (eff !== f.meilisearchField) fieldLabelMap[eff] = getFilterLabel(f);
    });
    var effectiveFieldToFilter = {};
    sortedFilters.forEach(function (f) {
      effectiveFieldToFilter[getEffectiveField(f)] = f;
    });

    var sliders = {};

    sortedFilters.forEach(function (filter) {
      var baseField = filter.meilisearchField;
      var effectiveField = getEffectiveField(filter);

      if (isSliderFilter(filter)) {
        var facetEl = document.getElementById('ms-facet-' + baseField);
        var minInput = document.getElementById('ms-slider-min-' + baseField);
        var maxInput = document.getElementById('ms-slider-max-' + baseField);
        var sliderFill = document.getElementById('ms-slider-fill-' + baseField);
        var valMin = document.getElementById('ms-range-val-min-' + baseField);
        var valMax = document.getElementById('ms-range-val-max-' + baseField);
        if (!facetEl || !minInput || !maxInput) return;

        sliders[baseField] = { refine: null, appliedMin: null, appliedMax: null };

        (function (bf, ef, facetEl, minInp, maxInp, fill, vMin, vMax, pre, suf, step) {
          var isDecimal = step < 1;
          function fmtVal(n) {
            var formatted = isDecimal
              ? n.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, "'")
              : Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
            return (pre ? pre + ' ' : '') + formatted + (suf ? ' ' + suf : '');
          }
          function updateUI() {
            if (!minInp || !maxInp || !fill) return;
            var min = parseFloat(minInp.value);
            var max = parseFloat(maxInp.value);
            var rangeMin = parseFloat(minInp.min) || 0;
            var rangeMax = parseFloat(minInp.max) || 999999;
            var total = rangeMax - rangeMin;
            if (total <= 0) return;
            var leftPct = ((min - rangeMin) / total) * 100;
            var rightPct = ((max - rangeMin) / total) * 100;
            fill.style.left = leftPct + '%';
            fill.style.width = (rightPct - leftPct) + '%';
            if (vMin) vMin.textContent = fmtVal(min);
            if (vMax) vMax.textContent = fmtVal(max);
          }

          minInp.addEventListener('input', function () {
            if (parseFloat(minInp.value) >= parseFloat(maxInp.value)) minInp.value = parseFloat(maxInp.value) - step;
            updateUI();
          });
          maxInp.addEventListener('input', function () {
            if (parseFloat(maxInp.value) <= parseFloat(minInp.value)) maxInp.value = parseFloat(minInp.value) + step;
            updateUI();
          });

          minInp.addEventListener('change', function () {
            var min = parseFloat(minInp.value);
            var rangeMin = parseFloat(minInp.min);
            sliders[bf].appliedMin = (min > rangeMin) ? min : null;
            _search.helper.removeNumericRefinement(ef, '>=');
            if (min > rangeMin) {
              _search.helper.addNumericRefinement(ef, '>=', min);
            }
            _search.helper.search();
          });

          maxInp.addEventListener('change', function () {
            var max = parseFloat(maxInp.value);
            var rangeMax = parseFloat(maxInp.max);
            sliders[bf].appliedMax = (max < rangeMax) ? max : null;
            _search.helper.removeNumericRefinement(ef, '<=');
            if (max < rangeMax) {
              _search.helper.addNumericRefinement(ef, '<=', max);
            }
            _search.helper.search();
          });

          var _initialized = false;
          var renderSlider = window.instantsearch.connectors.connectRange(
            function (renderState) {
              sliders[bf].refine = renderState.refine;
              var range = renderState.range;
              var start = renderState.start;
              if (range && range.min != null && range.max != null && range.min !== range.max) {
                facetEl.style.display = '';
                minInp.min = range.min; minInp.max = range.max;
                maxInp.min = range.min; maxInp.max = range.max;
                sliders[bf].appliedMin = (start && isFinite(start[0])) ? start[0] : null;
                sliders[bf].appliedMax = (start && isFinite(start[1])) ? start[1] : null;
                var isCleared = !start || (!isFinite(start[0]) && !isFinite(start[1]));
                if (!_initialized || isCleared) {
                  _initialized = true;
                  minInp.value = (start && isFinite(start[0])) ? start[0] : range.min;
                  maxInp.value = (start && isFinite(start[1])) ? start[1] : range.max;
                  updateUI();
                } else {
                  minInp.value = (start && isFinite(start[0])) ? Math.max(range.min, Math.min(range.max, parseFloat(minInp.value) || range.min)) : range.min;
                  maxInp.value = (start && isFinite(start[1])) ? Math.max(range.min, Math.min(range.max, parseFloat(maxInp.value) || range.max)) : range.max;
                  updateUI();
                }
                var labelEl = facetEl.querySelector('.ms-facet-label');
                var isActive = start && (isFinite(start[0]) || isFinite(start[1]));
                if (labelEl) labelEl.classList.toggle('ms-facet-label--active', !!isActive);
              } else {
                facetEl.style.display = 'none';
              }
            }
          );
          _search.addWidgets([renderSlider({ attribute: ef })]);
        }(baseField, effectiveField, facetEl, minInput, maxInput, sliderFill, valMin, valMax,
          filter.stripPrefix || filter.prefix || '', filter.stripSuffix || filter.suffix || '', parseFloat(filter.step) || 1));

      } else {
        // List (checkbox) filter
        var facetEl = document.getElementById('ms-facet-' + baseField);
        var ul = document.getElementById('ms-facet-list-' + baseField);
        if (!facetEl || !ul) return;

        var currentRefine = null;
        var currentItems = [];

        ul.addEventListener('change', function (e) {
          if (e.target.type === 'checkbox' && currentRefine) {
            currentRefine(e.target.dataset.value);
          }
        });

        var customRefinement = window.instantsearch.connectors.connectRefinementList(
          function (renderState, isFirstRender) {
            currentRefine = renderState.refine;
            currentItems = renderState.items;

            if (isFirstRender) return;

            facetEl.style.display = renderState.items.length === 0 ? 'none' : '';
            if (renderState.items.length === 0) return;

            var hasRefined = renderState.items.some(function (i) { return i.isRefined; });
            var labelEl = facetEl.querySelector('.ms-facet-label');
            if (labelEl) labelEl.classList.toggle('ms-facet-label--active', hasRefined);

            ul.innerHTML = renderState.items.map(function (item) {
              var inputId = 'ms-facet-' + sanitizeId(baseField) + '-' + sanitizeId(item.value);
              return (
                '<li>' +
                '<input type="checkbox"' +
                ' id="' + inputId + '"' +
                ' class="ms-facet-option"' +
                ' data-value="' + escapeHtml(item.value) + '"' +
                (item.isRefined ? ' checked' : '') + '>' +
                '<label for="' + inputId + '" class="ms-facet-option-label' + (item.isRefined ? ' ms-facet-option-label--active' : '') + '">' +
                '<span class="ms-facet-option-value">' + escapeHtml(item.label) + '</span>' +
                '<span class="ms-facet-option-count">(' + item.count + ')</span>' +
                '</label>' +
                '</li>'
              );
            }).join('');
          }
        );

        _search.addWidgets([customRefinement({
          attribute: effectiveField,
          operator: 'or',
          limit: 100,
          sortBy: ['name:asc']
        })]);
      }
    });

    var _currentRefinementsState = null;

    function renderActiveFacetsHtml(items) {
      if (!items || !items.length) return '';

      var numericByAttr = {};
      var orderedAttrs = [];
      var listItems = [];

      items.forEach(function (item) {
        var numericRefs = [];
        var otherRefs = [];
        item.refinements.forEach(function (r) {
          if (r.type === 'numeric' || r.operator) {
            numericRefs.push(r);
          } else {
            otherRefs.push(r);
          }
        });
        if (numericRefs.length) {
          if (!numericByAttr[item.attribute]) {
            numericByAttr[item.attribute] = { attribute: item.attribute, refinements: [], refineItems: [] };
            orderedAttrs.push(item.attribute);
          }
          numericRefs.forEach(function (r) {
            numericByAttr[item.attribute].refinements.push(r);
          });
          numericByAttr[item.attribute].refineItems.push(item);
        }
        if (otherRefs.length) {
          listItems.push({ attribute: item.attribute, refinements: otherRefs, refine: item.refine });
        }
      });

      function fmtRangeVal(attr, n) {
        if (attr === 'price.minPrice') {
          return 'CHF ' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        }
        var f = effectiveFieldToFilter[attr];
        var pre = (f && f.stripPrefix) || '';
        var suf = (f && f.stripSuffix) || '';
        return pre + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'") + suf;
      }

      var tags = [];

      // One chip per bound - min and max are independent
      orderedAttrs.forEach(function (attr) {
        var merged = numericByAttr[attr];
        merged.refinements.forEach(function (r) {
          var isMin = (r.operator === '>=' || r.operator === '>');
          var label = escapeHtml(fieldLabelMap[attr] || attr);
          var valueText = (isMin ? '\u2265 ' : '\u2264 ') + fmtRangeVal(attr, r.value);
          tags.push(
            '<div class="ms-active-facet">' +
            '<span class="ms-active-facet-option">' + label + ': </span>' +
            '<span class="ms-active-facet-value">' + escapeHtml(valueText) + '</span>' +
            '<span class="ms-active-facet-x"' +
            ' data-attr="' + escapeHtml(attr) + '"' +
            ' data-op="' + escapeHtml(r.operator) + '"' +
            ' data-val="' + escapeHtml(String(r.value)) + '">clear</span>' +
            '</div>'
          );
        });
      });

      listItems.forEach(function (item) {
        item.refinements.forEach(function (r) {
          tags.push(
            '<div class="ms-active-facet">' +
            '<span class="ms-active-facet-option">' + escapeHtml(fieldLabelMap[item.attribute] || item.attribute) + ': </span>' +
            '<span class="ms-active-facet-value">' + escapeHtml(r.label) + '</span>' +
            '<span class="ms-active-facet-x" data-attr="' + escapeHtml(item.attribute) + '" data-val="' + escapeHtml(String(r.value)) + '">clear</span>' +
            '</div>'
          );
        });
      });

      return tags.join('<span>|</span>');
    }

    function syncActiveFacets(items) {
      var wrapper = document.getElementById('ms-active-facets-container');
      var desktop = document.getElementById('ms-active-facets');
      var modal = document.getElementById('ms-modal-active-facets');
      var hasRefinements = items && items.length > 0 && items.some(function (i) { return i.refinements.length > 0; });

      if (wrapper) wrapper.style.display = hasRefinements ? '' : 'none';

      var html = renderActiveFacetsHtml(items);

      if (desktop) desktop.innerHTML = html;

      if (modal) {
        var removeAllHtml = hasRefinements
          ? '<div class="ms-facets-remove-all" id="ms-modal-remove-all"><span>Alles löschen</span></div>'
          : '';
        modal.innerHTML = hasRefinements
          ? removeAllHtml + '<div class="ms-active-facets">' + html + '</div>'
          : '';
      }
    }

    function handleActiveFacetClick(e) {
      var x = e.target.closest('.ms-active-facet-x');
      if (!x || !_currentRefinementsState) return;
      var attr = x.dataset.attr;
      var op = x.dataset.op;
      var val = x.dataset.val;
      if (op) {
        // Range chip: op is '>=' / '<='
        var isMinOp = (op === '>=' || op === '>');
        sortedFilters.forEach(function (f) {
          if (isSliderFilter(f) && getEffectiveField(f) === attr && sliders[f.meilisearchField]) {
            if (isMinOp) sliders[f.meilisearchField].appliedMin = null;
            else sliders[f.meilisearchField].appliedMax = null;
          }
        });
        _search.helper.removeNumericRefinement(attr, op);
        _search.helper.search();
        return;
      }
      // List filter: match by value
      var matched = false;
      _currentRefinementsState.items.forEach(function (item) {
        if (item.attribute === attr) {
          item.refinements.forEach(function (r) {
            if (String(r.value) === val) {
              matched = true;
              _currentRefinementsState.refine(r);
            }
          });
        }
      });
    }

    function handleRemoveAll(e) {
      if (!e.target.closest('.ms-facets-remove-all')) return;
      if (!_currentRefinementsState) return;
      Object.keys(sliders).forEach(function (k) {
        sliders[k].appliedMin = null; sliders[k].appliedMax = null;
      });
      _currentRefinementsState.items.forEach(function (item) {
        item.refinements.forEach(function (r) {
          _currentRefinementsState.refine(r);
        });
      });
    }

    var renderCurrentRefinements = window.instantsearch.connectors.connectCurrentRefinements(
      function (renderState, isFirstRender) {
        _currentRefinementsState = renderState;
        syncActiveFacets(renderState.items);

        if (isFirstRender) {
          document.addEventListener('click', function (e) {
            handleActiveFacetClick(e);
            handleRemoveAll(e);
          });
        }
      }
    );
    _search.addWidgets([renderCurrentRefinements({})]);

    var renderStats = window.instantsearch.connectors.connectStats(
      function (renderState) {
        var el = document.getElementById('ms-pg-count');
        if (el) el.textContent = renderState.nbHits + ' Produkte';
      }
    );
    _search.addWidgets([renderStats({})]);

    var sortSpans = document.querySelectorAll('.ms-sort-option');
    var sortItems = [];
    sortSpans.forEach(function (span) {
      var val = span.dataset.value
        ? MEILISEARCH_INDEX + ':' + span.dataset.value
        : DEFAULT_SORT;
      sortItems.push({ label: span.textContent.trim(), value: val });
    });

    var renderSortBy = window.instantsearch.connectors.connectSortBy(
      function (renderState, isFirstRender) {
        sortSpans.forEach(function (span) {
          var val = span.dataset.value
            ? MEILISEARCH_INDEX + ':' + span.dataset.value
            : DEFAULT_SORT;
          var isActive = val === renderState.currentRefinement;
          span.classList.toggle('ms-sort-option--active', isActive);
          if (isActive) {
            var trigger = document.querySelector('.ms-sort-select-trigger');
            if (trigger) trigger.textContent = span.textContent.trim();
          }
        });

        if (isFirstRender) {
          sortSpans.forEach(function (span) {
            span.addEventListener('click', function () {
              var val = span.dataset.value
                ? MEILISEARCH_INDEX + ':' + span.dataset.value
                : DEFAULT_SORT;
              renderState.refine(val);
            });
          });
        }
      }
    );
    _search.addWidgets([renderSortBy({ items: sortItems })]);

    var _showMore = null;
    var _didClickShowMore = false;

    var renderHits = window.instantsearch.connectors.connectInfiniteHits(
      function (renderState, isFirstRender) {
        var container = document.getElementById('ms-hits');
        var showMoreBtn = document.querySelector('.ms-show-more-btn');
        if (!container) return;

        _showMore = renderState.showMore;

        if (isFirstRender) {
          if (showMoreBtn) showMoreBtn.style.display = 'none';

          if (showMoreBtn && !showMoreBtn._msListener) {
            showMoreBtn._msListener = true;
            showMoreBtn.addEventListener('click', function () {
              _didClickShowMore = true;
              if (_showMore) _showMore();
            });
          }
          return;
        }

        var toolbarEl = document.querySelector('.ms-toolbar');
        if (toolbarEl) toolbarEl.classList.add('ms-toolbar--ready');

        if (showMoreBtn) {
          showMoreBtn.style.display = renderState.isLastPage ? 'none' : '';
          showMoreBtn.disabled = renderState.showMoreLoading;
        }

        var wrapperEl = document.getElementById('ms-pg-wrapper');
        var noResultsEl = document.getElementById('meilisearch-no-results');

        if (searchMode && renderState.hits.length === 0) {
          container.innerHTML = '';
          if (wrapperEl) wrapperEl.style.display = 'none';
          if (noResultsEl) noResultsEl.style.display = 'block';
        } else if (renderState.hits.length === 0) {
          container.innerHTML = '<li class="ms-pg-no-results">Keine Produkte gefunden.</li>';
        } else {
          if (noResultsEl) noResultsEl.style.display = 'none';
          if (wrapperEl) wrapperEl.style.display = '';
          if (_didClickShowMore) {
            _didClickShowMore = false;
            var existingCards = container.querySelectorAll('.ms-product-card-container:not([style*="pointer-events"])');
            var newHits = renderState.hits.slice(existingCards.length);
            if (newHits.length) {
              container.insertAdjacentHTML('beforeend', newHits.map(renderHitHtml).join(''));
            }
          } else {
            container.innerHTML = renderState.hits.map(renderHitHtml).join('');
          }
          fetchBrandDeliveryDays();
        }
      }
    );
    _search.addWidgets([renderHits({})]);

    if (searchMode) {
      var virtualSearchBox = window.instantsearch.connectors.connectSearchBox(function () {});
      _search.addWidgets([virtualSearchBox({})]);
    }

    _search.start();

    initMobileFilter();
  }

  function initMobileFilter() {
    var toggle = document.getElementById('ms-pg-filter-toggle');
    var sidebar = document.getElementById('ms-pg-sidebar');
    var close = document.getElementById('ms-pg-sidebar-close');

    if (!toggle || !sidebar) return;

    toggle.addEventListener('click', function () {
      sidebar.classList.add('ms-pg-sidebar--open');
      document.body.classList.add('ms-pg-overlay-active');
    });

    function closeSidebar() {
      sidebar.classList.remove('ms-pg-sidebar--open');
      document.body.classList.remove('ms-pg-overlay-active');
    }

    if (close) close.addEventListener('click', closeSidebar);

    document.addEventListener('click', function (e) {
      if (
        document.body.classList.contains('ms-pg-overlay-active') &&
        !sidebar.contains(e.target) &&
        !toggle.contains(e.target)
      ) {
        closeSidebar();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }

})();
